import React from "react";
import "./style/PageNotFound.css";

const PageNotFound = () => {
  return (
    <>
      <div className="wrapper">
        <div className="container">
          <div>
            <h1 className="PageNotFound">404</h1>
            <p>PAGE NOT FOUND</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
